"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SwitcherToggler = exports.SwitcherHeader = exports.SwitcherContainer = exports.Solution = exports.LevelLink = exports.DropdownTitle = exports.DropdownHeaderInner = exports.DropdownHeader = exports.DropdownCloseBtn = exports.DropdownBody = exports.Dropdown = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Dropdown = _interopRequireDefault(require("../../../../components/Icons/Dropdown"));
var _Clear = _interopRequireDefault(require("../../../../components/Icons/Clear"));
const SwitcherContainer = exports.SwitcherContainer = _styledComponents.default.div.withConfig({
  displayName: "styles__SwitcherContainer",
  componentId: "sc-1l3034k-0"
})(["position:relative;width:100%;opacity:1;transition:opacity 0.3s ease-in-out;", ";"], ({
  collapsed
}) => collapsed && `
    opacity: 0;
  `);
const SwitcherHeader = exports.SwitcherHeader = _styledComponents.default.h1.withConfig({
  displayName: "styles__SwitcherHeader",
  componentId: "sc-1l3034k-1"
})(["font-family:", ";font-size:11px;line-height:16px;font-weight:500;letter-spacing:1px;text-transform:uppercase;user-select:none;color:", ";padding-left:36px;padding-right:18px;white-space:nowrap;cursor:pointer;position:relative;overflow:hidden;text-overflow:ellipsis;"], ({
  theme
}) => theme.fonts.preferred, ({
  theme
}) => theme.colors.appFrame.menu.switcherHeaderTextColor);
const SwitcherToggler = exports.SwitcherToggler = (0, _styledComponents.default)(_Dropdown.default).withConfig({
  displayName: "styles__SwitcherToggler",
  componentId: "sc-1l3034k-2"
})(["fill:", ";position:absolute;right:4px;top:50%;transform:translateY(-50%);"], ({
  theme
}) => theme.colors.appFrame.menu.switcherTogglerColor);
const Dropdown = exports.Dropdown = _styledComponents.default.div.withConfig({
  displayName: "styles__Dropdown",
  componentId: "sc-1l3034k-3"
})(["position:absolute;background-color:", ";width:calc(", " - 16px);z-index:200;top:-6px;left:-8px;box-shadow:0 2px 4px 0 ", ";"], ({
  theme
}) => theme.colors.appFrame.menu.switcherBg, ({
  theme
}) => theme.AppFrame.menu.expandedWidth, ({
  theme
}) => theme.colors.appFrame.menu.switcherShadow);
const DropdownHeader = exports.DropdownHeader = _styledComponents.default.div.withConfig({
  displayName: "styles__DropdownHeader",
  componentId: "sc-1l3034k-4"
})(["height:40px;padding:0 16px;"]);
const DropdownHeaderInner = exports.DropdownHeaderInner = _styledComponents.default.div.withConfig({
  displayName: "styles__DropdownHeaderInner",
  componentId: "sc-1l3034k-5"
})(["display:flex;flex-direction:row;align-items:center;border-bottom:1px solid ", ";height:100%;position:relative;"], ({
  theme
}) => theme.colors.appFrame.menu.switcherLine);
const DropdownTitle = exports.DropdownTitle = _styledComponents.default.h1.withConfig({
  displayName: "styles__DropdownTitle",
  componentId: "sc-1l3034k-6"
})(["font-family:", ";font-size:11px;font-weight:500;letter-spacing:1px;text-transform:uppercase;user-select:none;color:", ";"], ({
  theme
}) => theme.fonts.preferred, ({
  theme
}) => theme.colors.appFrame.menu.switcherText);
const DropdownCloseBtn = exports.DropdownCloseBtn = (0, _styledComponents.default)(_Clear.default).withConfig({
  displayName: "styles__DropdownCloseBtn",
  componentId: "sc-1l3034k-7"
})(["bottom:auto;top:50%;transform:translateY(-50%);fill:", ";cursor:pointer;position:absolute;right:0;"], ({
  theme
}) => theme.colors.appFrame.menu.switcherText);
const DropdownBody = exports.DropdownBody = _styledComponents.default.ul.withConfig({
  displayName: "styles__DropdownBody",
  componentId: "sc-1l3034k-8"
})(["list-style:none;margin:8px 0;overflow-y:auto;max-height:350px;"]);
const LevelLink = exports.LevelLink = _styledComponents.default.a.withConfig({
  displayName: "styles__LevelLink",
  componentId: "sc-1l3034k-9"
})(["display:block;color:", ";font-size:11px;font-weight:500;letter-spacing:1px;line-height:32px;text-transform:uppercase;width:100%;padding-right:15px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;opacity:0.65;"], ({
  theme
}) => theme.colors.appFrame.menu.switcherText);
const Solution = exports.Solution = _styledComponents.default.li.withConfig({
  displayName: "styles__Solution",
  componentId: "sc-1l3034k-10"
})(["height:32px;padding:0 16px;cursor:pointer;position:relative;&:hover{background-color:", ";", "{opacity:1;}}", ";"], ({
  theme
}) => theme.colors.appFrame.menu.switcherHoverBg, LevelLink, ({
  active,
  theme
}) => active && `
    &:before {
      bottom: auto;
      top: 50%;
      transform: translateY(-50%);
      content: '';
      display: block;
      width: 3px;
      height: 20px;
      background-color: ${theme.colors.appFrame.menu.itemActiveBadge};
      position: absolute;
      left: 0;
    }
  `);